import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { ReleaseHighlightsContent } from '@qiasphere/interfaces';

@Component({
  selector: 'qiasphere-release-highlights-dialog',
  templateUrl: './release-highlights-dialog.component.html',
  styleUrls: ['./release-highlights-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, MatIconModule]
})
export class ReleaseHighlightsDialogComponent {
  readonly data = inject<ReleaseHighlightsContent>(MAT_DIALOG_DATA);
}
